<div>
    <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="file-done" nzTheme="outline"></i> Premium Details
        <!-- <a nz-tooltip [nzTooltipTitle]="Premium Breakup data"><i nz-icon nzType="info-circle" nzTheme="outline"></i></a> -->
        </h3>  
        <div id="downloadButton" style="float:right">
            <!-- <h3><button nz-button class="m-r-20" [nzType]="'primary'" translate (click)="downloadPDF()">Download</button></h3> -->
            <h3><button nz-button class="m-r-20" [nzType]="'primary'" translate nz-popconfirm nzPopconfirmTitle="Are you sure?"
                    nzOkText="Download" nzCancelText="Cancel" (nzOnConfirm)="downloadPDF()">
                    Download
                </button></h3>
        </div>
    </div>
  <div id="premiumContent">
    <div class="summary-container grid grid-3x grid-gap-20 m-b-30">
        <div>
            <span class="s-c-head" translate>Term</span>
            <span>{{payloadData.policyTerm || '-'}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Currency</span>
            <span>{{payloadData.currencyCd || '-'}}</span>
            <!-- <span>{{(payloadData.currencyCd | technicalTranslate) || '-'}}</span> -->
        </div>
        <div>
            <span class="s-c-head" translate>Total Final Premium</span>
            <span>{{(payloadData.finalPremiumAmt | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Premium Payment Frequency</span>
            <span>{{(payloadData.paymentFrequencyCd | technicalTranslate) || '-'}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Installment Premium</span>
            <span *ngIf="payloadData.basePlan">{{(payloadData.finalPremiumAmt | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</span>
        </div>
        <div></div> <!--This blank div is added intentionally do move data to next row-->
        <div>
            <span class="s-c-head" translate>Policy Type</span>
            <span *ngIf="payloadData.basePlan">{{(payloadData.baseProductTypeCd | technicalTranslate) || '-'}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Product Name</span>
            <span>{{(payloadData.baseProductCd | technicalTranslate) || '-'}}</span>
        </div>
        <div>
            <span class="s-c-head" translate>Plan Option</span>
            <span>{{(payloadData.productPlanOptionCd | technicalTranslate) || '-'}}</span>
        </div>
    </div>

<nz-tabset>
    <nz-tab *ngFor="let item of premiumTermYears; let i = index;" [nzTitle]="'Year'+ (i+1)">
        
        <div class="table-header-vAlign">
            <nz-table #premiumTable nzBordered [nzData]="insuredPremiumData" [nzScroll]="{ x: '1100px' }">
                <thead>
                    <tr>
                        <th class="tableHead" style="width: 70px;">Sr No.</th>
                        <!-- <th rowspan="2">Insured Name</th>
                        <th rowspan="2">Insured ID</th>
                        <th rowspan="2">Insured Gender</th>
                        <th rowspan="2">Insured Age</th> -->
                        <!-- <th rowspan="2">Coverage Type</th> -->
                        <th style="width: 300px;">Coverage Name</th>
                        <!-- <th rowspan="2">Benefit Name</th> -->
                        <th style="width: 150px;">{{appMetadataHandler.SI_LABEL}}</th>
                        <th style="width: 120px;">Premium</th>
                        <th style="width: 120px;">Loading</th>
                        <th style="width: 120px;">Discount</th>
                        <th style="width: 100px;"*ngIf="this.baseCompanyCountryCd == 'INDIA'">CGST</th>
                        <th style="width: 100px;" *ngIf="this.baseCompanyCountryCd == 'INDIA'">SGST</th>
                        <th style="width: 100px;" *ngIf="this.baseCompanyCountryCd == 'INDIA'">IGST</th>
                        <!-- <th *ngIf="this.baseCompanyCountryCd == 'INDIA'">Tax</th> -->
                        <th style="width: 100px;" *ngIf="this.baseCompanyCountryCd == 'HONGKONG'">Tax</th>
                        <th style="width: 100px;" *ngIf="this.baseCompanyCountryCd == 'SINGAPORE'">GST</th>
                        <th nzRight="0px" style="width: 120px;">Total</th>
                    </tr>
                    <!-- <tr *ngIf="this.baseCompanyCountryCd == 'INDIA'">
                        <th>SGST</th>
                        <th>CGST</th>
                        <th>IGST</th>
                    </tr> -->
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of premiumTable.data; let i = index;">
                        <tr *ngIf="data.sumInsuredAmt > 0">
                            <td>{{ i+1 }}</td>
                            <!-- <td>{{ data.insuredName || '-'}}</td>
                            <td>{{ data.insuredID || '-'}}</td>
                            <td>{{ (data.insuredGender | technicalTranslate) || '-' }}</td>
                            <td>{{ data.insuredAge || '-' }}</td> -->
                            <!-- <td>{{ (data.coverageType | technicalTranslate) || '-' }}</td> -->
                            <td id="tableData">
                                <div>
                                    <!-- Technical Translate added after subscribing the productId lookupCd -->
                                    {{ (setProductName(data.coverageName)) }} <nz-tag [nzColor]="'green'" style="margin-left: 10px;"> {{ (data.coverageType | technicalTranslate) || '-' }}</nz-tag>
                                    <!-- {{ (data.coverageName | technicalTranslate : 'productId') || '-' }} <nz-tag [nzColor]="'green'" style="margin-left: 10px;"> {{ (data.coverageType | technicalTranslate) || '-' }}</nz-tag> -->
                                    <!-- [nzColor]="'#87d068'" -->
                                </div>
                            </td>
                            <td id="sum" >{{ (data.sumInsuredAmt | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue))  || '-'}}</td>
                            <td>{{ data.premium | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) || '-'}}</td>
                            <td>{{data.totalUWExtraPremiumAmt | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) || '-'}}</td>
                            <td>{{ data.discount |  CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) || '-'}}</td>
                            <td *ngIf="this.baseCompanyCountryCd == 'INDIA' || this.baseCompanyCountryCd == 'HONGKONG' || this.baseCompanyCountryCd == 'SINGAPORE'">{{ data.SGST || '-'}}</td>
                            <td *ngIf="this.baseCompanyCountryCd == 'INDIA'">{{ data.CGST || '-'}}</td>
                            <td *ngIf="this.baseCompanyCountryCd == 'INDIA'">{{ data.IGST || '-'}}</td>
                            <td nzRight="0px">{{ data.totalPremiumAmt |  CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) || '-'}}</td>
                        </tr>
                    </ng-container>
                    <tr >
                        <td nzRight="0px" colspan="8" class="text-a-right f-s-16p"><span id="total">Total Premium</span></td>
                        <td nzRight="0px" class="total-column" colspan="2">
                            <h3 id="premium" nz-typography nzType="success" class="text-a-right">{{ (payloadData.finalPremiumAmt | CurrencyFormatter : payloadData.currencyCd ) || '-' }}</h3>
                        </td>
                    </tr>
                </tbody>
            </nz-table>
        </div>

    </nz-tab>
</nz-tabset>

<div *ngIf="false">
<div class="table-header-vAlign" *ngIf="LOB == 'LIFE'">
    <nz-table #premiumTable nzBordered [nzData]="insuredPremiumData" [nzShowPagination]="false"
        [nzScroll]="{ x: '1100px' }">
        <thead>
            <tr>
                <th style="width: 250px;">Premium summary</th>
                <th style="width: 150px;">1st Year Premium</th>
                <th style="width: 150px;">2nd Year onwards</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of premiumTable.data; let i = index;">
                <td id="tableData">
                    <div class="flexie-auto-grid">
                        {{ (data.coverageName | technicalTranslate) || '-' }} <nz-tag [nzColor]="'#87d068'"> {{
                            (data.coverageType | technicalTranslate) || '-' }}</nz-tag>
                    </div>
                </td>
                <td id="sum" class="text-a-right">{{ (data.premium | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) ||
                    '-'}}</td>
                <td class="text-a-right" *ngIf="paymentFrequencyCd != 'SINGLE'">{{ data.premium | CurrencyFormatter :
                    (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) || '-'}}</td>
            </tr>
            <tr>
                <td class="tableHead" style="width: 80px;"><span id="total">Tax</span></td>
                <td class="text-a-right">{{ (getTaxComputed(firstYearPremium) | CurrencyFormatter :
                    (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</td>
                <td class="text-a-right" *ngIf="paymentFrequencyCd != 'SINGLE'">{{
                    (getTaxComputed(secondYearOnwardsPremium) | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}
                </td>
            </tr>
            <tr>
                <td class="tableHead" style="width: 80px;"><span id="total">Total Annual Premium with Tax</span></td>
                <td class="text-a-right">{{ (getTotalPremiumWithTax(firstYearPremium) | CurrencyFormatter :
                    (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</td>
                <td class="text-a-right" *ngIf="paymentFrequencyCd != 'SINGLE'">{{
                    (getTotalPremiumWithTax(secondYearOnwardsPremium) | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )||
                    '-'}}</td>
            </tr>
            <tr>
                <td class="tableHead" style="width: 80px;"><span id="total">Total Installment Premium (
                        {{paymentFrequencyCd | technicalTranslate}} )</span></td>
                <td class="text-a-right">{{ (getTotalInstallment(firstYearPremium) | CurrencyFormatter :
                    (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )|| '-'}}</td>
                <td class="text-a-right" *ngIf="paymentFrequencyCd != 'SINGLE'">{{
                    (getTotalInstallment(secondYearOnwardsPremium) | CurrencyFormatter : (payloadData.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue) )||
                    '-'}}</td>
            </tr>
        </tbody>
    </nz-table>
</div>
</div>

</div>
</div>
















